import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import getConfig from '../../../helpers/config';
import { getPrepareHeaders } from '../get-prepare-headers';
import { ModuleProps } from '../../../pages/Administration/ContinuousEducation/AdministrationOfModules/modules-constants';
import {
  PaginationProps,
  PaginationReturn,
} from '../../../interfaces/pagination';
import { getCommonUrl } from '../../../components/common/common-functions/commonApiUrl/get-common-url';

const { test } = getConfig();

export interface ModuleParams extends Partial<PaginationProps> {
  emertimi?: string;
}

export const moduliApi = createApi({
  reducerPath: 'moduliApi',
  baseQuery: fetchBaseQuery({
    baseUrl: test.baseUrl,
    prepareHeaders: getPrepareHeaders,
  }),
  tagTypes: ['Modulet', 'Moduli'],
  endpoints: builder => ({
    getModules: builder.query<PaginationReturn<ModuleProps>, ModuleParams>({
      query: args => ({
        url: getCommonUrl({ sortField: 'emertimi', ...args }, '/moduli'),
      }),
      providesTags: ['Modulet'],
    }),
    getModuleById: builder.query<ModuleProps, number>({
      query: id => ({
        url: `/moduli/${id}`,
      }),
      providesTags: ['Moduli'],
    }),
    createModule: builder.mutation<void, Partial<ModuleProps>>({
      query: ({ id, ...body }) => ({
        url: id ? `/moduli/${id}` : `/moduli`,
        method: id ? 'PUT' : 'POST',
        body,
      }),
      invalidatesTags: ['Modulet', 'Moduli'],
    }),
    deleteModules: builder.mutation<string, number>({
      query: arg => ({
        url: `/moduli/${arg}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Modulet'],
    }),
  }),
});

export const {
  useGetModulesQuery,
  useLazyGetModulesQuery,
  useCreateModuleMutation,
  useGetModuleByIdQuery,
  useDeleteModulesMutation,
} = moduliApi;
